import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { DefaultLayout } from "@components/Layouts";
import { url_reverse } from "@components/Utils";

export default function LandingCTEditScreen() {
    const { t } = useTranslation();
    const { item_id } = useParams();
    const navigate = useNavigate();
    const apiUrl = item_id
        ? url_reverse("api:landing_ct:landing_edit_delete", { pk: item_id })
        : url_reverse("api:landing_ct:landing_add");
    const { apiData, setApiData } = useAppApi(apiUrl);
    const backUrl = url_reverse("admin:landing_ct:landings");

    if (!apiData) return null;

    const header = (
        <>
            <Link to={url_reverse("admin:landing_ct:landings")}>{t("Лендинги")}</Link>
            <span> – </span>
            {item_id ? apiData?.forms_data?.main.data.name : t("Создание")}
        </>
    );

    return (
        <DefaultLayout>
            <Card>
                <Card.Header className="p-0">
                    <div className="dmg-card-header-title">{header}</div>
                </Card.Header>
                <Card.Body>
                    <RenderForm
                        apiData={apiData}
                        setApiData={setApiData}
                        afterRespOK={() => {
                            navigate(backUrl);
                        }}
                    />
                </Card.Body>
            </Card>
        </DefaultLayout>
    );
}
